<!--
 * @Author
  components: { Header },: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 11:30:58
-->
<template>
    <div>
        <a-layout>
            <a-layout-header>
                <Header ref="headerRef" @collapse="collapseMenu"></Header>
            </a-layout-header>
            <a-layout>
                <a-layout-sider :width="width" :theme="theme">
                    <Menu ref="refMenu" :menu="menu"></Menu>
                </a-layout-sider>
                <a-layout-content>
                    <BreadCrumb></BreadCrumb>
                    <div class="main">
                        <router-view></router-view>
                    </div>
                    <div class="footer" :class="{'footerCollapsed': width == 55}">Copyright © {{ year }} HEPHA. All rights reserved.</div>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, ref } from 'vue';
    import Header from './components/Header.vue';
    import Menu from './components/Menu.vue';
    import BreadCrumb from './components/BreadCrumb.vue';
    import { useLocale } from '@/store/index.js';
    import { menus } from './Menu';
   

    const localeStore = useLocale()

    const width = ref(230)
    const clientWidth = ref(document.body.clientWidth)
    const theme = ref('dark')
    const refMenu = ref(null)
    const headerRef = ref(null)
    const year = ref(new Date().getFullYear())
    // const menu = ref(menus)
    const menu = ref([])
    const role = ref(JSON.parse(sessionStorage.getItem('userInfo')).role.split(',')) // 当前登录人角色
    // console.log(role.value,'role',JSON.parse(sessionStorage.getItem('userInfo')).role)


    // 根据登录人角色展示菜单
    // const getMenu = ()=>{
    //     for(let i=0; i<menus.length; i++){
    //         let item = menus[i]
    //         for(let k=0; k<role.value.length; k++){
    //             if(item.auth.includes(role.value[k])){
    //                 menu.value.push(item)
    //                 break
    //             }
    //         }
    //     }
    // }

    const getMenu = (data, level = 0, parent = null)=>{
        if(!!parent) parent.children = []

        for(let i=0; i<data.length; i++){
            let item = data[i]
            if(level == 0){
                for(let k=0; k<role.value.length; k++){
                    if(item.auth && item.auth.includes(role.value[k])){
                        menu.value.push(item)
                        if(item.children){
                            getMenu(item.children, level + 1, item)
                        } 
                        break
                    }
                }
            }else{
                if(!item.children){
                    for(let k=0; k<role.value.length; k++){
                        if(item.auth && item.auth.includes(role.value[k])){
                            parent.children.push(item)
                            break
                        }
                    }
                }
            }
        }
        // console.log(menu.value,'menu.value')
    }
    
    const collapseMenu = (val)=>{
        width.value = val? 55 : 230
        refMenu.value.collapsed = val
    }

    window.onresize = ()=>{
        clientWidth.value = document.body.clientWidth 
        const clientHeight = document.body.clientHeight

        if(clientWidth.value <= 1700){
            width.value = 55
            headerRef.value.collapsed = true
            refMenu.value.collapsed = true
        }else{
            width.value = 230
            headerRef.value.collapsed = false
            refMenu.value.collapsed = false
        }
        localeStore.changeClientWidthAndHeight(clientWidth.value, clientHeight)
    }
    onMounted(()=>{
        nextTick(()=>{
            if(clientWidth.value <= 1700){
                width.value = 55
                headerRef.value.collapsed = true
                refMenu.value.collapsed = true
            }else{
                width.value = 230
                headerRef.value.collapsed = false
                refMenu.value.collapsed = false
            }
        })

        getMenu(menus)
    })

</script>

<style lang="less" scoped>
@menuWidth:230px;
@menuWidthCollapsed:55px;
.arco-layout{
    height: 100vh;
    overflow: hidden;
}
.arco-layout-content{
    background: #f5f5f5;
}

.main{
    padding: 5px 5px 50px 5px;
}

.footer{
    position: absolute;
    bottom: 0;
    z-index: 100;
    width:  calc(100% - @menuWidth);
    height: 30px;
    line-height: 30px;
    font-size:12px;
    text-align: center;
    border-top: 1px solid #ddd;
    background:#f3f3f3;
}
.footerCollapsed{
    width:  calc(100% - @menuWidthCollapsed);
}
</style>